import React from 'react';
// eslint-disable-next-line import/no-unresolved
import * as XLSX from 'xlsx';

const ExportCSVButton = ({ data, filename = 'exported-data.xlsx', buttonText = 'Export to Excel' }) => {
  const exportToExcel = () => {
    if (!data || data.length === 0) {
      // eslint-disable-next-line no-alert
      alert('No data to export');
      return;
    }

    try {
      // Clean data for Excel export - remove or truncate problematic fields
      const cleanedData = data.map((record) => {
        const cleanedRecord = { ...record };
        
        // Remove base64 image data and long text fields
        delete cleanedRecord.digilockerIdPhoto;
        delete cleanedRecord.faceImagePath;
        delete cleanedRecord.poiImagePath;
        
        // Truncate long text fields to prevent Excel cell limit errors
        if (cleanedRecord.digilockerAddress && cleanedRecord.digilockerAddress.length > 1000) {
          cleanedRecord.digilockerAddress = `${cleanedRecord.digilockerAddress.substring(0, 1000)}... (truncated)`;
        }
        
        if (cleanedRecord.poiName && cleanedRecord.poiName.length > 1000) {
          cleanedRecord.poiName = `${cleanedRecord.poiName.substring(0, 1000)}... (truncated)`;
        }
        
        // Ensure all string values are within Excel limits
        Object.keys(cleanedRecord).forEach((key) => {
          if (typeof cleanedRecord[key] === 'string' && cleanedRecord[key].length > 32767) {
            cleanedRecord[key] = `${cleanedRecord[key].substring(0, 32767)}... (truncated)`;
          }
        });
        
        return cleanedRecord;
      });

      // Create a new workbook
      const workbook = XLSX.utils.book_new();
      
      // Convert cleaned data to worksheet
      const worksheet = XLSX.utils.json_to_sheet(cleanedData);
      
      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      
      // Generate Excel file and trigger download
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      // eslint-disable-next-line no-alert
      alert('Error exporting data to Excel');
    }
  };

  return (
    <button
      type="button"
      onClick={exportToExcel}
      className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors duration-200 flex items-center space-x-2 whitespace-nowrap"
    >
      <svg 
        className="w-4 h-4" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
        />
      </svg>
      <span>{buttonText}</span>
    </button>
  );
};

export default ExportCSVButton; 